import axios from 'axios';
import RapidUtils from 'lib/RapidUtils';

async function getRapidBatchSearch(params, comparableType, targetCoords) {
    const response = await axios
        .post('api/rapid/search/batch', RapidUtils.searchFilterBuilder(params));
    return RapidUtils.formatRapidResponseToLegacy(response.data, comparableType, targetCoords || params.coordinates);
}

async function getAggregatedSearch(params) {
    const response = await axios
        .post('api/rapid/search/aggregate-search', RapidUtils.searchWithAggregateBuilder(params));
    return response.data;
}

const rapidBatchSearchApi = {
    getRapidBatchSearch,
    getAggregatedSearch,
};

export default rapidBatchSearchApi;
